import * as React from 'react';

import { NoPhoto } from '../NoPhoto';
import * as styles from './NewbuildingImageMobile.css';

export interface INewbuildingImageMobileProps {
  src?: string;
}

export const NewbuildingImageMobile: React.FC<INewbuildingImageMobileProps> = props => {
  const { src } = props;

  if (src) {
    return <img className={styles['image']} src={src} data-testid="NewbuildingImageMobile" />;
  }

  return <NoPhoto className={styles['no-photo']} />;
};
